/* Scoped token re-point only — see AuthTextInput.module.css for why these
   land on the component's own root. Astryx paints `Button variant="primary"`
   from --color-accent (fill) and --color-on-accent (label), so inverting the
   pair gives an ink button with a page-coloured label in both themes. */

.submit {
  --color-accent: var(--color-background-inverted);
  --color-on-accent: var(--color-background-body);
}
